import styled, { css, keyframes } from 'styled-components';
import { pxToRem } from '../../foundation/spacing/utils.js';
import { themeGet } from '../../foundation/theme/themeGet/get.js';
import { breakpoint } from '../../../deprecated/theme/breakpoints/values.js';

var deprecatedSizes = {
  small: pxToRem(480),
  compact: pxToRem(600),
  large: pxToRem(800)
};
var sizes = Object.assign({
  sm: pxToRem(480),
  md: pxToRem(600),
  lg: pxToRem(800),
  xl: css(["calc(100dvw - calc(2 * ", "))"], themeGet('spacing.7xl'))
}, deprecatedSizes);
var slideUpIn = keyframes(["0%{opacity:0;transform:translateY(", ");}80%{opacity:1;}100%{transform:translateY(0);}"], pxToRem(6));
var DialogContainer = styled.div.withConfig({
  displayName: "DialogContainer",
  componentId: "sc-yex44t-0"
})(["width:calc(100dvw - calc(2 * ", "));height:calc(100dvh - calc(2 * ", "));max-height:calc(100dvh - calc(2 * ", "));margin:", " auto;& > *{max-height:inherit;height:inherit;}", " @media ", "{width:", ";height:auto;max-height:80dvh;margin:10dvh auto;}"], themeGet('spacing.xl'), themeGet('spacing.xl'), themeGet('spacing.xl'), themeGet('spacing.xl'), function (_ref) {
  var $animate = _ref.$animate;
  return $animate && css(["animation:0.5s ", " forwards;"], slideUpIn);
}, breakpoint.desk, function (props) {
  return sizes[props.$size];
});

export { DialogContainer };
